import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import React, { Component, createRef } from "react";

export default class RidersPDF extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}
	// downloadPdfDocument = (rootElementId) => {
	// 	const input = document.getElementById(rootElementId);
	// 	html2canvas(input).then((canvas) => {
	// 		const imgData = canvas.toDataURL("image/png");
	// 		const pdf = new jsPDF();
	// 		pdf.addImage(imgData, "JPEG", 10, 10, 190, 200);
	// 		pdf.save("Agreement.pdf");
	// 	});
	// };
	downloadPdfDocument = (rootElementId) => {
		const input = document.getElementById(rootElementId);
		html2canvas(input).then((canvas) => {
		  const imgData = canvas.toDataURL("image/png");
		  const pdf = new jsPDF("p", "mm", "a4");
		  const imgWidth = 210;
		  const pageHeight = 297;
		  const imgHeight = (canvas.height * imgWidth) / canvas.width;
		  let heightLeft = imgHeight;
		  let position = 0;
	  
		  pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
		  heightLeft -= pageHeight;
	  
		  while (heightLeft >= 0) {
			position = heightLeft - imgHeight;
			pdf.addPage();
			pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;
		  }
	  
		  pdf.save("Agreement.pdf");
		});
	  };
	  
	
	
	render() {
		const {
			agreementDate = "",
			short_name = "",
			name = "",
		} = this.props.pdfData;
		return (
			<div
				className="position-fixed justify-content-around py-4"
				style={{
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: 1000,
					backgroundColor: "rgb(0 0 0 / 30%)",
					display: this.props.visible ? "flex" : "none",
				}}
			>
				<div
					className="bg-light w-50"
					style={{ overflowY: "auto", borderRadius: 10 }}
				>
					<div id="pdf-riders" className="position-relative py-2 px-5">
						<div
							className="position-absolute w-100 text-center"
							style={{ left: 0, right: 0 }}
						>
							<img src="/Picture2.png" height={60} />
						</div>
						<div className="d-flex justify-content-between">
							<img src="/Picture1.png" height={60} />
							<div className="d-flex flex-column">
								<span>Supported by:</span>
								<img src="/Picture3.png" height={20} />
							</div>
						</div>
						<div className="py-1 text-center">
							<u>
								<b>TERMS & CONDITIONS</b>
							</u>
						</div>
						<p className="text-body" style={{ fontSize: 12 }}>
							This Agreement is made on{" "}
							{moment(agreementDate).format("DD/MM/YYYY")}, by and between
							Mercy Corps (hereinafter “PR”) and the rider, {name} (hereinafter
							“Volunteer”): Volunteer intends to render his/her services to the
							PR for its intervention – Rider for Health, and the PR intends to
							accept Volunteer services. Both parties agree as follows:
						</p>

						<ol type="1" className="pl-5" style={{ fontSize: 12 }}>
							<li>
								Volunteer will participate in transporting sputum specimens
								either from the designated pick-up points to the designated
								diagnostic facilities within his/her assigned geographical area.
								S/he will be working with SR {short_name} for the aforesaid
								intervention. Volunteer further agrees to accept at least 60% of
								the sent job requests. SR will facilitate this intervention in
								the designated district of the Volunteer on behalf of Mercy
								Corps.{" "}
							</li>
							<li>
								Volunteer shall use a mobile application for booking rides,
								picking sputum sample from public/private healthcare facilities,
								and dropping it off at a diagnostic facility. Also, s/he will
								ensure the cold chain for sputum samples with provided ice packs
								and carrier boxes.
							</li>
							<li>
								Volunteer shall be responsible for the safety of the provided
								logistics, mainly sputum carrier boxes and ice packs provided by
								SR/PR, any damage to SR/PR property may result in a deduction
								from {"{his / her}"} incentive amount.
							</li>
							<li>
								Volunteer shall ensure that he has his own working smartphone,
								petrol in {"{his / her}"} motorbike, helmet, 3G/4G connection to
								the phone, CNIC, motorbike registration documents, and toolkit.{" "}
							</li>
							<li>
								No individual acting as Volunteer for this intervention becomes
								an employee of the SR/PR, and is not entitled to receive a
								salary, benefits, or other compensation. Besides an agreed
								incentive of 40 PKR/KM or 40 PKR/Sample (for the clusters with
								less than 1 KM distance). Incentives will be calculated by the
								developed system (application) and will be paid after the
								deduction of applicable taxes.
							</li>
							<li>
								Working as a Volunteer does not qualify an individual for SR/PR
								workers’ compensation benefits, and Volunteers are responsible
								for their own personal medical expenses for any injuries,
								traffic challans, motorbike maintenance, and other expenses
								incurred while performing volunteer services. SR/PR will not
								reimburse the Volunteer for any out-of-pocket expenses that
								Volunteer may incur in order to carry out any and all tasks
								related to the Volunteer position; the Volunteer agrees to take
								on all financial responsibilities related to the position.
							</li>
							<li>
								Either Party may terminate this agreement upon twenty-four (24)
								hours’ notice for any reason whatsoever, without penalty.
							</li>
							<li>
								Volunteer shall follow the supervision and direction of any
								personnel, employee, or Volunteer Leader to whom the Volunteer
								has been assigned to perform services and shall participate in
								any training required by the PR in order to perform the
								voluntary services.
							</li>
							<li>
								Volunteer shall maintain the confidential information of the
								organization. Any publicity in association with this
								intervention must be approved directly through the
								Organization’s communications department. Do not speak with
								media unless authorized first by the Organization.
							</li>
							<li>
								Volunteer should not post any photos, videos, or writing on the
								internet that is Organization related (including Facebook, and
								personal blogs). This includes sharing or linking media content
								that originated from the Organization (e.g. sharing the
								Organization’s Facebook post/photo).
							</li>
							<li>
								Notwithstanding anything to the contrary in this Agreement, PR
								shall have the absolute discretion to refuse to accept any
								volunteer for participation, and the sole right to terminate
								unilaterally at any time, any volunteer who does not meet the
								performance requirements of this Agreement.
							</li>
							<li>
								Both Parties hold each other harmless, indemnified, and release
								each other from any liabilities arising during the duration of
								this Agreement. However, should damages or harm arise due to
								negligence, insubordination, or criminal intent, the Volunteer
								may be subject to penalties up to and including criminal
								charges. The Volunteer agrees to cooperate with all
								investigations arising from such charges.
							</li>
						</ol>

						<div
							className="d-flex justify-content-center w-100 pt-4 align-items-end"
							style={{ fontSize: 12 }}
						>
							<div className="d-flex flex-column justify-content-center text-center">
								<img src="/signature.png" />
								<b className="border-top border-dark">
									<b>(Dr. Adeel Tahir, Senior Technical Advisor)</b>
								</b>
							</div>
						</div>
					</div>

					<div
						className="d-flex justify-content-end py-2 px-5"
						style={{ gap: 5 }}
					>
						<button
							className="btn btn-primary"
							onClick={() => this.downloadPdfDocument("pdf-riders")}
						>
							<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
							&nbsp;Download pdf
						</button>
						<button
							className="btn btn-secondary"
							onClick={this.props.closePdfModal}
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		);
	}
}
